import React, { useState } from "react";
import { Link } from "react-router-dom";

import { updateApplicationStatus } from "../../../../api/jobApplications";
import { apiErrorHandler } from "../../../../helpers/common";
import { CustomSnackbar } from "../../../../helpers/CustomSnackbar";
import { Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Input } from "reactstrap";

export const RejectButton = ({ data, invalidateApi }) => {
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [isOther, setIsOther] = useState(false);
  const [customReason, setCustomReason] = useState("");

  const toggleModal = () => setModal(!modal);

  const handleCheckboxChange = (reasonText) => {
    if (selectedReasons.includes(reasonText)) {
      setSelectedReasons(selectedReasons.filter((r) => r !== reasonText));
    } else {
      setSelectedReasons([...selectedReasons, reasonText]);
    }
  };

  const shortListApplication = () => {
    let allReasons = [...selectedReasons];
    if (isOther && customReason.trim()) {
      allReasons.push(customReason.trim());
    }

    if (allReasons.length === 0) {
      return CustomSnackbar.error("Please select or enter rejection reason.");
    }

    const finalReason = allReasons.join(", ");

    setLoading(true);

    updateApplicationStatus({
      status: "Rejected",
      id: data.id,
      rejectionReason: finalReason, // sending reject reason
    })
      .then((res) => {
        if (res) {
          invalidateApi();
          CustomSnackbar.success("Application rejected successfully.");
          setModal(false);
          setSelectedReasons([]);
          setIsOther(false);
          setCustomReason("");
        }
      })
      .catch((err) => {
        apiErrorHandler(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Link
        to="#"
        className="btn btn-danger"
        onClick={toggleModal}
      >
        Reject
      </Link>

      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>
          Reject Application
        </ModalHeader>

        <ModalBody>
          <label className="mb-3 fw-semibold">
            Specify the reason for rejection to notify the applicant
          </label>

          {[
            "Hiring is complete",
            "Requirements do not match",
            "Experience level does not align",
            "Position already filled",
          ].map((item, index) => (
            <div className="form-check mb-2" key={index}>
              <input
                type="checkbox"
                className="form-check-input"
                id={`reason-${index}`}
                checked={selectedReasons.includes(item)}
                onChange={() => handleCheckboxChange(item)}
              />
              <label className="form-check-label fw-normal" htmlFor={`reason-${index}`}>
                {item}
              </label>
            </div>
          ))}

          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="reason-other"
              checked={isOther}
              onChange={() => setIsOther(!isOther)}
            />
            <label className="form-check-label fw-normal" htmlFor="reason-other">
              Other (Specify reason)
            </label>
          </div>

          {isOther && (
            <Input
              type="textarea"
              rows="3"
              placeholder="Enter custom rejection reason..."
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
              className="mt-2"
            />
          )}
        </ModalBody>

        <ModalFooter>
          <button
            className="btn btn-secondary"
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={shortListApplication}
            disabled={loading}
          >
            {loading ? (
              <>
                Rejecting <Spinner size="sm" />
              </>
            ) : (
              "Reject"
            )}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};